import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { translate } from '../../locales';
import './style.css';

const ServicesPage: React.FC = () => {
  const { language } = useLanguage();
  const t = (key: any) => translate(key, language as 'en' | 'ua');

  return (
    <div className="services-page">
      <h1>{t('pages.services.title')}</h1>
      <p>{t('pages.services.description')}</p>
      {/* TODO: Implement services management */}
    </div>
  );
};

export default ServicesPage;
